export default {
  admin: "Admin",
  member: "Member",
  organization: "Organization",
  updateMember: "Update Member",
  deactivateMember: "Deactivate",
  reactivateMember: "Reactivate",
  changeRoleToMember: "Change Role to Member",
  changeRoleToAdmin: "Change Role to Admin",
  changeRoleToOwner: "Change Role to Owner",
  activeTeamMembers: "Active Team Members ({{count}})",
  deactivated: "Deactivated Team Members ({{count}})",
  teamMemberDeleted: "Team member deactivated",
  deactivateMemberTitle: "Deactivate team member",
  deactivateMemberMessage:
    "Are you sure you want to deactivate {{name}}? They will lose access to the organization. You can reactivate them later.",
  scheduleSettings: "Schedule Settings",
  timezone: "Timezone",
  workingDays: "Working Days",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  scheduleSettingsUpdated: "Schedule settings updated successfully",
  atLeastOneWorkingDay: "At least one working day must be selected",
  contributor: "Contributor",
  addTeamMember: "Add Team Member",
  addTeamMemberMenu: "Add Team Member Menu",
  addContributor: "Add Contributor",
  addContributorDescription:
    "Add a contributor to your team. Contributors are managed via Slack and do not need to log in.",
  editContributor: "Edit Contributor",
  deleteContributor: "Delete Contributor",
  deleteContributorConfirm:
    "This will permanently remove the contributor and all their time entries. This action cannot be undone.",
  deleteConfirmPhrase: "DELETE",
  deleteContributorTypePrompt: "Type {{phrase}} to confirm.",
  deleteContributorTypeMismatch: "The confirmation phrase does not match.",
  contributorCreatedSuccess:
    "Contributor added. They'll be matched to Slack on next sync.",
  contributorUpdatedSuccess: "Contributor updated successfully.",
  contributorDeletedSuccess: "Contributor removed successfully.",
  slackMatched: "Matched",
  slackMatchedTooltip: "This contributor is linked to a Slack account.",
  slackUnmatched: "Unmatched",
  slackUnmatchedTooltip:
    "This contributor has not been matched to a Slack account yet. They will be matched automatically on the next sync.",
  addAnother: "Add another",
  emailChangeSlackNote:
    "Changing the email may require Slack to re-sync the mapping.",
  hourlyRate: "Hourly Rate",
  costRate: "Cost Rate",
  readOnlyNotice:
    "You're viewing these settings in read-only mode. Contact your organization admin to make changes.",
  editRate: "Edit Rate",
  editTeamMember: "Edit Team Member",
  rateUpdatedSuccess: "Rate updated successfully.",
  teamMemberUpdatedSuccess: "Team member updated successfully.",
  notifications: {
    title: "Notification routing",
    description:
      "Choose who receives each notification from invup about this organization. Leave a rule blank to use the default; the organization owner and admins.",
    save: "Save changes",
    cancel: "Cancel",
    saved: "Notification routing saved",
    addEmailPlaceholder: "Add an email…",
    defaultBadge: "Defaults to owner + admins",
    footerNote: "Press Enter or comma to add each recipient.",
    invalidEmail: "Enter a valid email address.",
    duplicate: "“{{email}}” is already a recipient.",
    duplicateNotificationType:
      "Each notification can only be configured once per organization.",
    groups: {
      invoices: "Invoices",
      payments: "Payments",
      forms: "Forms",
    },
    types: {
      invoice_sent: {
        label: "Invoice sent",
        description:
          "When an invoice is sent to a client (manual or scheduled).",
      },
      invoice_paid: {
        label: "Invoice paid",
        description:
          "When a client pays an invoice and a transaction is recorded.",
      },
      recurring_invoice_created: {
        label: "Recurring invoice created",
        description:
          "When a new invoice is generated from a recurring schedule.",
      },
      transaction_receipt: {
        label: "Transaction receipt",
        description: "Cc'd on the receipt email when a client pays an invoice.",
      },
      form_submitted: {
        label: "Form response submitted",
        description: "When a client submits a response to one of your forms.",
      },
    },
  },
};
